import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import DepositLeft from '@/components/bridge/Left/DepositLeft'
import { WithdrawLeft } from '@/components/bridge/Left/WithdrawLeft'
import BridgeLayout from '@/components/bridge/Layout'
import { WalletType, useWallet } from '@/components/common/WalletContext'
import TokenInfo from '@/components/bridge/TokenInfo'
import { setPageCache } from '@/cache'

type BridgeMode = 'deposit' | 'withdraw'

const BridgeModeMap: Record<WalletType, BridgeMode> = {
  Btc: 'deposit',
  Evm: 'withdraw',
}

const BridgePage = () => {
  const [mode, setMode] = useState<BridgeMode>('deposit')

  const { walletType } = useWallet()

  useEffect(() => {
    // console.log('walletType: ', walletType)
    if (!walletType) return
    setMode(BridgeModeMap[walletType])
  }, [walletType])

  return (
    <BridgeLayout>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 50,
          flexDirection: { xs: 'column', md: 'row' },
        }}
      >
        {mode === 'withdraw' ? <WithdrawLeft /> : <DepositLeft />}
        <TokenInfo />
      </Box>
    </BridgeLayout>
  )
}

export default BridgePage

export async function getServerSideProps({ req, res }) {
  setPageCache(req, res)
  return {
    props: {},
  }
}
